import { renderSlot as _renderSlot, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "sfe-input-wrap"
};
const _hoisted_2 = {
  class: "sfe-input-left"
};
const _hoisted_3 = {
  class: "sfe-input-left_input"
};
const _hoisted_4 = ["id", "disabled", "placeholder", "maxlength"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "prepend"), _createElementVNode("div", {
    class: _normalizeClass(['sfe-input flex-items-center flex-row-space-between', $setup.isFocus ? 'sfe-input-focus' : '', $setup.isHover ? 'sfe-input-hover' : '', $props.disabled ? 'sfe-input-disabled' : '', $props.error ? 'is-error' : '']),
    onMouseover: _cache[4] || (_cache[4] = $event => $setup.onHover(true)),
    onMouseleave: _cache[5] || (_cache[5] = $event => $setup.onHover(false))
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
    id: $props.id,
    disabled: $props.disabled,
    class: "sfe-input-left__inner",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.inputRef = $event),
    onInput: _cache[1] || (_cache[1] = (...args) => $setup.onInput && $setup.onInput(...args)),
    onFocus: _cache[2] || (_cache[2] = (...args) => $setup.onFocus && $setup.onFocus(...args)),
    onBlur: _cache[3] || (_cache[3] = (...args) => $setup.onBlur && $setup.onBlur(...args)),
    placeholder: $props.placeholder,
    maxlength: $props.maxlength,
    autocomplete: "off"
  }, null, 40, _hoisted_4), [[_vModelText, $setup.inputRef]])])]), _renderSlot(_ctx.$slots, "append")], 34), $props.errorText ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    innerHTML: $props.errorText,
    class: "spot-theme-text-red mt-4px fz12 leading-18px break-word"
  }, null, 8, _hoisted_5)) : $props.tip ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    innerHTML: $props.tip,
    class: "spot-theme-text-t3 mt-4px fz12 leading-18px break-word"
  }, null, 8, _hoisted_6)) : _createCommentVNode("", true)]);
}